export const formData = [
    {
        order: 0,
        rowClass: "row",

        name: "row-8",
        fields: [
            {
                order: 0,
                name: "specific-field-name-section1", // name is also a key in JSON
                value:
                    "We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.",
                type: "section", // available types: text, number, date, checkbox, select, list and button
                label: "Nowa sekcja",

                required: false,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 20, // used only to validate text fields
                minValue: 0.0, // must be float or double and is used only to type number
                maxValue: 100.0, // must be float or double and is used only to type number
                pattern: "",
                placeholder: "Wpisz nazwę pola",
                helpText: "Pole musi zawierać od 3 do 20 znaków",
                colClass: "col",
            },
        ],
    },
    {
        order: 0,
        rowClass: "row",
        name: "row-0",
        fields: [
            {
                order: 0,
                name: "specific-field-name-0", // name is also a key in JSON
                value: null,
                type: "text", // available types: text, number, date, checkbox, select, list and button
                label: "Nazwa pola",
                required: false,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 20, // used only to validate text fields
                minValue: 0.0, // must be float or double and is used only to type number
                maxValue: 100.0, // must be float or double and is used only to type number
                pattern: "^[a-zA-Z0-9]+$",
                placeholder: "Wpisz nazwę pola",
                helpText: "Pole musi zawierać od 3 do 20 znaków",
                colClass: "col",
            },
        ],
    },
    {
        order: 0,
        rowClass: "row",
        name: "row-1",
        fields: [
            {
                order: 0,
                name: "dateFrom", // name is also a key in JSON
                value: null,
                type: "date", // available types: text, number, date, checkbox, select, list and button
                label: "Jakas data",
                required: false,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 20, // used only to validate text fields
                minValue: 0.0, // must be float or double and is used only to type number
                maxValue: 100.0, // must be float or double and is used only to type number
                pattern: null,
                placeholder: "Wpisz datę",
                helpText: "Pole musi zawierać datę w formacie yyyy-MM-dd",
                colClass: "col col-lg-6",
            },
            {
                order: 0,
                name: "dateTo", // name is also a key in JSON
                value: null,
                type: "date", // available types: text, number, date, checkbox, select, list and button
                label: "Jakas data",
                required: false,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 20, // used only to validate text fields
                minValue: 0.0, // must be float or double and is used only to type number
                maxValue: 100.0, // must be float or double and is used only to type number
                pattern: null,
                placeholder: "Wpisz datę",
                helpText: "Pole musi zawierać datę w formacie yyyy-MM-dd",
                colClass: "col col-lg-6",
            },
        ],
    },
    {
        order: 0,
        rowClass: "row",
        name: "row-2",
        fields: [
            {
                order: 0,
                name: "nameField", // name is also a key in JSON
                value: null,
                type: "text", // available types: text, number, date, checkbox, select, list and button
                label: "Imię",
                required: false,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 20, // used only to validate text fields
                minValue: 0.0, // must be float or double and is used only to type number
                maxValue: 100.0, // must be float or double and is used only to type number
                pattern: "^[a-zA-Z0-9]+$",
                placeholder: "Wpisz nazwę pola",
                helpText: "Pole musi zawierać od 3 do 20 znaków",
                colClass: "col col-lg-3",
            },
            {
                order: 0,
                name: "surnameField", // name is also a key in JSON
                value: null,
                type: "text", // available types: text, number, date, checkbox, select, list and button
                label: "Nazwisko",
                required: false,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 20, // used only to validate text fields
                minValue: 0.0, // must be float or double and is used only to type number
                maxValue: 100.0, // must be float or double and is used only to type number
                pattern: "^[a-zA-Z0-9]+$",
                placeholder: "Wpisz nazwę pola",
                helpText: "Pole musi zawierać od 3 do 20 znaków",
                colClass: "col col-lg-3",
            },
            {
                order: 0,
                name: "emailField", // name is also a key in JSON
                value: null,
                type: "text", // available types: text, number, date, checkbox, select, list and button
                label: "@",
                required: false,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 20, // used only to validate text fields
                minValue: 0.0, // must be float or double and is used only to type number
                maxValue: 100.0, // must be float or double and is used only to type number
                pattern: "^[a-zA-Z0-9]+$",
                placeholder: "Wpisz adres e-mail",
                helpText: "Pole musi zawierać od 3 do 20 znaków",
                colClass: "col col-lg-3",
            },
            {
                order: 0,
                name: "phoneField", // name is also a key in JSON
                value: null,
                type: "text", // available types: text, number, date, checkbox, select, list and button
                label: "Tel.",
                required: false,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 20, // used only to validate text fields
                minValue: 0.0, // must be float or double and is used only to type number
                maxValue: 100.0, // must be float or double and is used only to type number
                pattern: "^[a-zA-Z0-9]+$",
                placeholder: "+48 000000000",
                helpText: "Pole musi zawierać od 3 do 20 znaków",
                colClass: "col col-lg-3",
            },
        ],
    },

    {
        order: 0,
        rowClass: "row",
        name: "row-3",
        fields: [
            {
                order: 0,
                name: "specific-field-name-section2", // name is also a key in JSON
                value:
                    "We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.",
                type: "section", // available types: text, number, date, checkbox, select, list and button
                label: "Sekcja wyboru",
                required: false,
                options: [], // for select type
                minLength: 3, // used only to validate text fields
                maxLength: 20, // used only to validate text fields
                minValue: 0.0, // must be float or double and is used only to type number
                maxValue: 100.0, // must be float or double and is used only to type number
                pattern: "",
                placeholder: "",
                helpText: "",

                colClass: "col",
            },
        ],
    },

    {
        order: 0,
        rowClass: "row",
        name: "row-4",
        fields: [
            {
                order: 0,
                name: "answerOne", // name is also a key in JSON
                value: false,
                type: "checkbox", // available types: text, number, date, checkbox, select,file, list and button
                label: "Zanzacz tę opcję jeśli się zgadzasz",
                required: true,
                options: [], // for select type
                minLength: null, // used only to validate text fields
                maxLength: null, // used only to validate text fields
                minValue: null, // must be float or double and is used only to type number
                maxValue: null, // must be float or double and is used only to type number
                pattern: null,
                placeholder: "",
                helpText: "Zanzacz tę opcję jeśli się zgadzasz",
                colClass: "col col-lg-3",
            },
            {
                order: 0,
                name: "answerTwo", // name is also a key in JSON
                value: false,
                type: "checkbox", // available types: text, number, date, checkbox, select,file, list and button
                label: "To jest inna opcja",
                required: true,
                options: [], // for select type
                minLength: null, // used only to validate text fields
                maxLength: null, // used only to validate text fields
                minValue: null, // must be float or double and is used only to type number
                maxValue: null, // must be float or double and is used only to type number
                pattern: null,
                placeholder: "",
                helpText: "Zanzacz tę opcję jeśli się zgadzasz",
                colClass: "col col-lg-3",
            },
            {
                order: 0,
                name: "answerThree", // name is also a key in JSON
                value: false,
                type: "checkbox", // available types: text, number, date, checkbox, select,file, list and button
                label: "A tu jeszcze inna opcja",
                required: true,
                options: [], // for select type
                minLength: null, // used only to validate text fields
                maxLength: null, // used only to validate text fields
                minValue: null, // must be float or double and is used only to type number
                maxValue: null, // must be float or double and is used only to type number
                pattern: null,
                placeholder: "",
                helpText: "Zanzacz tę opcję jeśli się zgadzasz",
                colClass: "col col-lg-3",
            },
            {
                order: 0,
                name: "answerFour", // name is also a key in JSON
                value: false,
                type: "checkbox", // available types: text, number, date, checkbox, select,file, list and button
                label: "No i ostatnia opcja",
                required: true,
                options: [], // for select type
                minLength: null, // used only to validate text fields
                maxLength: null, // used only to validate text fields
                minValue: null, // must be float or double and is used only to type number
                maxValue: null, // must be float or double and is used only to type number
                pattern: null,
                placeholder: "",
                helpText: "Zanzacz tę opcję jeśli się zgadzasz",
                colClass: "col col-lg-3",
            },
        ],
    },
];
